import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxurybusrentalforalandiyatra() {



const cardData =
{
  keyword: 'Luxury Bus Rental for Alandi Yatra',
  heading: 'Sanavi Travels: Luxury Bus Rental for Alandi Yatra',
  headingDescription: 'Sanavi Travels offers premium and well-managed Luxury Bus Rental for Alandi Yatra, specially curated for devotees, Warkari groups, families, senior citizens, corporate spiritual outings, wedding ritual visits, and large pilgrimage groups traveling to the holy town of Alandi. Alandi, the sacred Samadhi place of Sant Dnyaneshwar Maharaj, attracts thousands of pilgrims throughout the year, with massive footfall during Ashadhi and Kartiki Wari, Ekadashi, weekends, and special religious occasions. Traveling in a luxury bus ensures a calm, dignified, and comfortable journey, allowing devotees to remain spiritually focused without the stress of traffic, heat, or crowded public transport.',

  top: 'Spiritual & Travel Highlights of Alandi Yatra',

  "topPlaces": [
    {
      "title": "Alandi Samadhi Temple",
      "description": "The Samadhi of Sant Dnyaneshwar Maharaj is the spiritual heart of Alandi. Luxury bus travel ensures devotees arrive fresh, relaxed, and mentally prepared for darshan, especially during crowded yatra days."
    },
    {
      "title": "Ashadhi & Kartiki Wari Travel",
      "description": "During Wari season, Alandi sees massive pilgrim movement. Luxury buses help groups travel together comfortably, avoiding travel fatigue and logistical confusion."
    },
    {
      "title": "Ekadashi Darshan Trips",
      "description": "Ekadashi days attract heavy crowds. Luxury bus rentals ensure smooth group coordination, punctual arrival, and comfortable return travel."
    },
    {
      "title": "Family Religious Visits",
      "description": "Families visiting Alandi benefit from luxury buses that offer safe seating, controlled temperature, and stress-free travel for elders and children."
    },
    {
      "title": "Senior Citizen Yatra Groups",
      "description": "Luxury buses are ideal for senior devotees, providing smooth suspension, easy boarding, and reduced physical strain during travel."
    },
    {
      "title": "Bhajan Mandal & Warkari Groups",
      "description": "Bhajan mandals and Warkari groups prefer luxury buses for collective travel, devotional singing, and maintaining group harmony."
    },
    {
      "title": "Wedding & Ritual Temple Visits",
      "description": "Many families visit Alandi for wedding rituals and blessings. Luxury buses add dignity and comfort to such sacred journeys."
    },
    {
      "title": "Corporate Spiritual Outings",
      "description": "Companies organize spiritual trips to Alandi for employees. Luxury bus travel ensures professional, punctual, and organized transportation."
    },
    {
      "title": "One-Day & Overnight Yatra Plans",
      "description": "Luxury buses support flexible travel plans, whether it is a one-day darshan or an overnight stay with early morning aartis."
    },
    {
      "title": "Peaceful & Organized Group Travel",
      "description": "With expert drivers handling navigation and traffic, devotees can focus fully on devotion and spiritual reflection."
    }
  ],

  "services": [
    {
      "name": "Luxury Bus Rental for Alandi Yatra",
      "description": "Sanavi Travels provides specialized luxury bus rental services for Alandi Yatra, ensuring a premium, safe, and spiritually calm travel experience. This service includes modern luxury buses, experienced drivers, flexible scheduling, and smooth group coordination, making it ideal for pilgrims, families, and religious organizations."
    },
    {
      "name": "AC Luxury Bus Alandi",
      "description": "AC luxury buses offer climate-controlled comfort, plush seating, and smooth rides, especially beneficial during summer yatras and crowded festival days."
    },
    {
      "name": "Non AC Luxury Bus Alandi",
      "description": "Non-AC luxury buses provide spacious interiors and economical pricing while maintaining comfort and safety for devotional travel."
    },
    {
      "name": "Mini Luxury Bus Hire Alandi",
      "description": "Mini luxury buses are perfect for small groups and families seeking flexibility, comfort, and easy maneuverability."
    },
    {
      "name": "32 Seater Luxury Bus Alandi",
      "description": "32 seater luxury buses are ideal for medium-sized pilgrimage groups, offering balanced seating capacity and premium comfort."
    },
    {
      "name": "35 Seater Luxury Bus Alandi",
      "description": "35 seater luxury buses support large yatra groups, bhajan mandals, and community pilgrimages traveling together."
    },
    {
      "name": "Luxury Bus for Family Alandi",
      "description": "Family-friendly luxury bus services ensure safe, comfortable, and peaceful travel for all age groups."
    },
    {
      "name": "Luxury Bus for Corporate Alandi",
      "description": "Corporate luxury buses are suitable for employee spiritual outings, leadership retreats, and organized devotional trips."
    },
    {
      "name": "Luxury Bus for Group Alandi",
      "description": "Group luxury bus services allow all pilgrims to travel together, ensuring unity, punctuality, and stress-free coordination."
    },
    {
      "name": "Affordable Luxury Bus Rental Alandi",
      "description": "Affordable luxury bus packages offer premium comfort at transparent and budget-friendly pricing."
    },
    {
      "name": "Best Luxury Bus Service Alandi",
      "description": "Sanavi Travels is trusted as one of the best luxury bus service providers for Alandi Yatra."
    },
    {
      "name": "Luxury Bus with Driver Alandi",
      "description": "All luxury bus rentals include trained drivers experienced with Alandi routes and yatra traffic management."
    },
    {
      "name": "Luxury Bus for Wedding Alandi",
      "description": "Luxury buses add elegance and comfort to wedding-related temple visits and ritual travel."
    },
    {
      "name": "Luxury Bus for Picnic Alandi",
      "description": "Picnic-style spiritual outings to Alandi are more enjoyable with comfortable luxury bus travel."
    },
    {
      "name": "Luxury Bus for Tour Alandi",
      "description": "Luxury bus tour packages support combined temple visits, sightseeing, and devotional travel."
    }
  ],

  "tableData": [
    ["Luxury Bus Alandi Yatra", "AC Luxury Bus"],
    ["Non AC Luxury Bus", "Mini Luxury Bus"],
    ["32 Seater Luxury Bus", "35 Seater Luxury Bus"],
    ["Family Travel", "Group Travel"],
    ["Corporate Trip", "Wedding Travel"]
  ],

  "whychoose": [
    { "WhyChooseheading": "Premium Comfort Travel", "WhyChoosedescription": "Luxury buses provide a calm and comfortable yatra experience." },
    { "WhyChooseheading": "Experienced Yatra Drivers", "WhyChoosedescription": "Drivers understand Alandi traffic and pilgrimage routes." },
    { "WhyChooseheading": "Clean & Sanitized Buses", "WhyChoosedescription": "All buses are hygienically maintained." },
    { "WhyChooseheading": "Flexible Pickup Points", "WhyChoosedescription": "Pickup locations can be customized for groups." },
    { "WhyChooseheading": "Multiple Luxury Bus Options", "WhyChoosedescription": "Mini, 32 seater, and 35 seater luxury buses available." },
    { "WhyChooseheading": "Transparent Pricing", "WhyChoosedescription": "Clear pricing with no hidden charges." },
    { "WhyChooseheading": "Group Coordination Support", "WhyChoosedescription": "Smooth management for large yatra groups." },
    { "WhyChooseheading": "Trusted Pilgrimage Partner", "WhyChoosedescription": "Sanavi Travels is trusted for Alandi Yatra transport." }
  ]
};

const faqData = [
  { question: 'Do you provide luxury buses for Alandi Yatra?', answer: 'Yes, Sanavi Travels offers luxury bus rental services for Alandi Yatra.' },
  { question: 'Are AC luxury buses available?', answer: 'Yes, both AC and Non-AC luxury buses are available.' },
  { question: 'Is this service suitable for senior citizens?', answer: 'Yes, luxury buses are ideal for elderly devotees.' },
  { question: 'Do you support Wari season travel?', answer: 'Yes, we provide luxury buses during Ashadhi and Kartiki Wari.' },
  { question: 'Can we book for one-day Alandi trips?', answer: 'Yes, one-day and overnight trips are supported.' },
  { question: 'Is driver included?', answer: 'Yes, all luxury bus rentals include experienced drivers.' },
  { question: 'What seating options are available?', answer: 'Mini, 32 seater, and 35 seater luxury buses are available.' },
  { question: 'Are buses sanitized before travel?', answer: 'Yes, all buses are cleaned and sanitized before each trip.' },
  { question: 'Can pickup points be customized?', answer: 'Yes, pickup locations can be customized as per group needs.' },
  { question: 'Is Alandi considered an outstation trip?', answer: 'Yes, Alandi Yatra is handled as an outstation luxury bus service.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vitthal Jadhav',
    feedback: 'Excellent luxury bus service for Alandi Yatra. Very peaceful and comfortable journey.',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Sunita Kulkarni',
    feedback: 'Best luxury bus experience for Alandi. Clean bus and very polite driver.',
    rating: 5
  }
];




































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];






const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Luxury Bus Rental for Alandi Yatra - Sanavi Travels",
  "description": "Sanavi Travels offers luxury bus rentals for Alandi Yatra, including family trips, corporate travel, group tours, weddings, picnics, and tour packages. AC and Non-AC luxury buses, mini buses, 32-seater and 35-seater options are available with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};










  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Luxury Bus Rental for Alandi Yatra | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book luxury bus rental for Alandi Yatra with Sanavi Travels. AC & Non-AC mini buses, 32-seater and 35-seater buses for family trips, corporate travel, group tours, weddings, picnics, and tours with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/269.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Luxurybusrentalforalandiyatra;